import React, { useState, useEffect } from 'react';
import { Button } from '@wajeez-web/components/ui';
import { SuperAdminSystemPermissions } from '@wajeez-web/core/types';
import { WajeezList, WajeezRow } from '@wajeez-web/components/list-builder';
import { PlusIcon } from '@heroicons/react/solid';
import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import {
  AuthorsActions,
  useContentSelector,
  ContentEntityActions,
} from '@wajeez-web/stores/content';

import { useCommonDispatch } from '@wajeez-web/stores/common';
import { CallBackSelector } from '@wajeez-web/components/ui';

interface AssignAuthorsModalProps extends CommonModalProps<unknown> {
  contentId: string;
}

const AssignAuthorsModal: React.FC<AssignAuthorsModalProps> = ({
  isOpen,
  onClose,

  contentId,
}) => {
  const [selectedAuthors, setSelectedAuthors] = useState<
    { value: number; label: string } | undefined
  >(undefined);
  const { selectedContenrAuthorsStatus, selectedContentAuthors } =
    useContentSelector((state) => state.authors);
  const dispatch = useCommonDispatch();
  const onSearch = (val: string) => {
    return dispatch(AuthorsActions.getAuthorsLookUpsAsync(val)).then((res) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return res?.payload?.map((item: { id: number; name: string }) => ({
        label: item.name,
        value: item.id,
      }));
    });
  };
  const getAuthors = () => {
    dispatch(
      AuthorsActions.getContentEntityAuthorsAsync({
        ContentEntityId: contentId,
        page: 1,
        pageSize: 10,
      })
    );
  };
  useEffect(() => {
    getAuthors();
    return () => {
      dispatch(AuthorsActions.clearSelectedContentAuthors());
    };
  }, [contentId]);

  return (
    <Modal title={'Assign Authors'} open={isOpen} onClose={onClose}>
      <>
        <div className="flex space-s-2">
          <div className="w-full">
            {' '}
            <CallBackSelector
              name={'authors'}
              // value={selectedAuthors}
              onSearch={onSearch}
              onChange={(name, value: any) => setSelectedAuthors(value)}
            />
          </div>
          <Button
            type="primary"
            bg="primary"
            shape="circle"
            color="white"
            Icon={PlusIcon}
            onClick={() => {
              dispatch(
                AuthorsActions.assignAuthortoContentAsync({
                  contentEntityId: contentId,
                  authorId: selectedAuthors?.value,
                  order: 0,
                })
              ).then(() => {
                getAuthors();
              });
            }}
          />{' '}
        </div>
        <div className="overflow-y-auto  scrollbar-thin scrollbar-thumb-gray-400 ">
          <div className="overflow-y-auto  scrollbar-thin scrollbar-thumb-gray-400 ">
            <WajeezList
              getData={getAuthors}
              containerType="rows"
              isLoading={selectedContenrAuthorsStatus === 'loading'}
              data={selectedContentAuthors}
              keyExtractor={(item) => item.id?.toString() || ''}
              renderItem={(item) => (
                <WajeezRow
                  key={item.id}
                  title={item.name}
                  headerActions={[
                    {
                      label: 'delete',
                      type: 'action',
                      onClick: () => {
                        dispatch(
                          AuthorsActions.unAssignAuthortoContentAsync({
                            contentEntityId: contentId,
                            authorId: item.id,
                          })
                        ).then(() => {
                          getAuthors();
                        });
                      },
                    },
                  ]}
                />
              )}
            />
          </div>
        </div>
      </>
    </Modal>
  );
};

export default AssignAuthorsModal;
